import { refundHoldModeOptions } from './constants'

export const getRefundHoldModeOptions = t => {
  return refundHoldModeOptions.map(option => {
    return {
      ...option,
      label: t(option.label),
    }
  })
}
